<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" role="dialog" v-if="isAdmin">
      <div class="modal" ref="modal">
        <header class="modal-header">
          <div class="flex justify-between items-center border-b border-gray-200 px-5 py-3">
            <h2 class="font-bold">
              Are you sure you want to delete this message?
            </h2>

            <button
              class="ml-10 px-2 py-1 font-bold rounded-md hover:bg-gray-200"
              @click="cancel"
              aria-label="Close modal"
            >
              x
            </button>
          </div>
        </header>

        <section class="modal-body">
          <div class="px-5 py-10 border-b border-gray-200">
            <topic-message-display :message="message"></topic-message-display>
          </div>
        </section>

        <footer class="modal-footer">
          <div class="flex justify-center p-5">
            <div class="flex justify-around">
              <button
                class="inline-flex items-center justify-center px-5 py-3 mx-2 border border-transparent bg-green rounded-md tracking-wider
              text-white hover:bg-peach transition duration-150 ease-in-out"
                @click="confirm"
              >
                Confirm
              </button>
              <button
                class="inline-flex items-center justify-center px-5 py-3 mx-2 border border-transparent bg-gray-500 rounded-md tracking-wider
              text-white hover:bg-peach transition duration-150 ease-in-out"
                @click="cancel"
              >
                cancel
              </button>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import TopicMessageDisplay from "./TopicMessageDisplay";
import {mapGetters} from "vuex";

export default {
  name: "ConfirmationModal",
  components: {
    TopicMessageDisplay
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapGetters(["isAdmin"]),
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>
<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  z-index: 1000;
}
</style>
